import Component from '../lib/component';

class Fan extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props };

    // Track the click events
    this.clickHandler = this.clickHandler.bind(this);
    document.addEventListener('DOMContentLoaded', () => {
      const app = document.getElementById('inputs');
      app.addEventListener('click', this.clickHandler);
    });
  }

  clickHandler(event) {
    event.preventDefault();

    const {
      data: { componentName },
    } = this.state;

    // Get event target element and its parent
    const target = event.target || event.srcElement;
    if (!target) return;
    const parent = target.parentElement || target.parentNode;
    if (!parent) return;

    // Check if an action button for this component was clicked
    if (target.getAttribute('data-source') === componentName || target.parentElement.getAttribute('data-source') === componentName) {
      // Update status prop
      this.updateStatus();
    }
  }

  updateStatus() {
    // Set state status prop with new value
    this.setState({ status: !this.state.data.status });
  }

  // Define the template elements
  template(props) {
    const { componentName, status, temp, limit } = props;
    this.temp = `
        <div class="rpc-section__fan">
          <!-- Fan - input (hidden) -->
          <input type="checkbox" name="fan" id="fan"/>
          <!-- Fan - label -->
          <label class="rpc-section__fan-label ${temp > limit ? '' : 'rpc-section__fan-label-heat'} ${
      status ? 'active' : ''
    }" for="fan" data-source="${componentName}">
            <span>${temp > limit ? 'ac' : 'heat'} ${status ? 'on' : 'off'}</span>
            <i class="rpc-section__fan-label-icon"></i>
          </label>
        </div>
      `;

    return this.temp;
  }
}

export default Fan;
